import Image from "next/image";
import Typography from "@mui/material/Typography";

import { ProviderHooks } from "@/src/hook";
import { StrapiComponentType, DeepSkyType, StrapiCollectionType } from "@/src/type";

import { ButtonLinkModule } from "../../../component/ButtonLinkModule";

import styles from "./Header.module.scss";

interface HeaderProps {
  propertyUnitDetails: StrapiComponentType.Section.PropertyUnitDetails;
  floorplan: DeepSkyType.AssetType.PropertyInventory.MarketingFloorPlan;
  propertyFloorplan?: StrapiCollectionType.PropertyFloorplan;
}

export default function Header({ propertyUnitDetails, floorplan, propertyFloorplan }: HeaderProps) {
  const cms = ProviderHooks.useCMS();
  const { filtersQuery } = ProviderHooks.useProperty();
  return (
    <header className={styles.header}>
      <div className={styles.content}>
        {/** ${propertySlug} when detected by constructLink will be replaced with the real property slug */}
        <a 
          className={styles.prevWrapper} 
          href={cms.constructLink("${propertySlug}/available-homes" + (filtersQuery ? `?${filtersQuery}` : ""))}
        >
          <Image
            src={"/image/icon_arrow_down_thick_dark.svg"}
            width={40}
            height={40}
            alt="Previous Page"
            className={styles.prev}
          />
          <Typography variant="body1" className={styles.prevLabel}>
            {propertyUnitDetails.backButtonTitle}
          </Typography>
        </a>
        <div className={styles.titleWrapper}>
          <Typography variant="body1" className={styles.title}>
            {propertyFloorplan?.title ?? floorplan.name}
          </Typography>
        </div>
        <div className={styles.cta}>
          {propertyUnitDetails.headerCta && (
            <ButtonLinkModule 
              buttonLink={propertyUnitDetails.headerCta} 
              className={styles.button} 
            />
          )}
        </div>
      </div>
    </header>
  );
}
